import DealList from 'views/DealList/DealList';
export default DealList;
